import StepStoneText from "../text/step_stone_text";
import replaceTextInString from "../../../objects/CommonUse/replace_text_in_string";

export const stepStoneReplaceText = (stepStoneType, newCareerName, careerName, careerNbrMonths) => {
      let stepStoneArr = StepStoneText;
      let shortStepStoneText = "";
      let stepStoneFullText = "";
      for (let i=0; i<stepStoneArr.length; i++){
          if (stepStoneArr[i].type === stepStoneType){
              const initialShortStepStoneText = stepStoneArr[i].shortText;
              stepStoneFullText = stepStoneArr[i].text
              let replaceObj = {careerName: newCareerName,
                  stepCareerName: careerName,
                  nbrMonths: careerNbrMonths};
              shortStepStoneText = replaceTextInString(initialShortStepStoneText, replaceObj);
              break;  
          }
       }
       const returnObj = {shortStepStoneText: shortStepStoneText, stepStoneFullText: stepStoneFullText}
       return returnObj;
}
export default stepStoneReplaceText;